import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialogActions } from '@angular/material/dialog';

@Component({
  selector: 'app-timer-dialog',
  templateUrl: './timer-dialog.component.html',
  styleUrl: './timer-dialog.component.css'
})
export class TimerDialogComponent {
  remainingTime: number;
  private interval: any;

  constructor(
    public dialogRef: MatDialogRef<TimerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { duration: number }
  ) {
    this.remainingTime = data.duration;
    this.startCountdown();
  }

  startCountdown() {
    this.interval = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime <= 0) {
        clearInterval(this.interval);
        this.dialogRef.close();
      }
    }, 1000);
  }

  onClose(): void {
    clearInterval(this.interval);
    this.dialogRef.close();
  }
}
